import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';

@Component({
  selector: 'app-new-open-chart',
  templateUrl: './new-open-chart.component.html',
  styleUrls: ['./new-open-chart.component.scss']
})
export class NewOpenChartComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;
  @Input() chartOptions: any;
  @Input() role: any;
  @Input() loading: boolean;


  @Output() optionSelected = new EventEmitter();

  selected = {
    type: 'Gói dịch vụ',
    value: 'package',
    tab: "day"
  };

  option = [
    {
      value: 'package',
      type: 'Gói dịch vụ',
    },
    {
      value: 'device',
      type: 'Loại loa',
    },
    {
      value: 'deliveryMethod',
      type: 'Phương thức nhận hàng',
    },
    {
      value: 'status',
      type: 'Tình trạng đơn hàng',
    },
    {
      value: 'active',
      type: 'Cửa hàng active',
    },
  ];

  setActiveTab(event: Event, tab: string) {
    event.preventDefault();
    this.selected = {
      ...this.selected,
      tab: tab,
    }
    this.optionSelected.emit(this.selected);
  }

  selectOption(event: Event, value: string, type: string) {
    event.preventDefault();
    this.selected = {
      ...this.selected,
      value: value,
      type: type
    }
    this.optionSelected.emit(this.selected);
  }

  fullname = JSON.parse(localStorage.getItem("currentUser"))["full_name"];


updateOptions() {
  
    // Nếu không phải mb_operation thì mới thêm tất cả options
    this.option = [
      {
        value: 'package',
        type: 'Gói dịch vụ',
      },
      {
        value: 'device',
        type: 'Loại loa',
      },
      {
        value: 'deliveryMethod',
        type: 'Phương thức nhận hàng',
      },
      {
        value: 'status',
        type: 'Tình trạng đơn hàng',
      },
    ];
  
    // Chỉ thêm "Cửa hàng active" nếu fullname khác "mb_operation"
    if (this.fullname !== 'mb_quanlychinhanh') {
      this.option.push({
        value: 'active',
        type: 'Cửa hàng active',
      });
    }
  
    // Nếu là admin hoặc partner_operation thì thêm Kênh bán
    if (this.role === 'admin' || this.role === 'partner_operation') {
      this.option.push({
        value: 'salesChannel',
        type: 'Kênh bán',
      });
    }
  }
  constructor() {
  }

  ngOnInit(): void {
    this.updateOptions()
  }


}
